export default {
  GET_THE_APP: 'Consigue la aplicaci\u00f3n',
  MAKE_FLOCK_BETTER_APPS: 'Haz que Flock sea incluso mejor con aplicaciones',
  URL_APP_DECORATOR_NO_PROMPT_TEXT:
    'Vale, no te sugeriremos aplicaciones para {appOrDomain}.\nVisita la {flockStore} para descubrir aplicaciones.',
  FLOCK_APP_STORE: 'Flock App Store',
};
